'use strict';

module.exports = (error, trackyName, message, moduleName) => {
  const { payload: { allowConsoleErrors } = {} } = window;
  if (allowConsoleErrors) {
    if (message) {
      console.error(message); // eslint-disable-line no-console
    }
    console.error(error); // eslint-disable-line no-console
  }
  if (window.OptimizeSuite && window.OptimizeSuite.TrackingHub) {
    if (error instanceof Error) {
      error = {
        message: error.message || error.description,
        name: error.name,
        stack: error.stack,
      };
    }

    if (moduleName) {
      error.moduleName = moduleName;
    }

    window.OptimizeSuite.TrackingHub.add(trackyName, {
      error,
    });
  }
};
